export default __webpack_public_path__ + "static/media/logo.173a479a.png";